import { GerenciadorPrecos } from '../../../../../../@types/GerenciadorPrecos';
import { Sort } from '../../../../../../@types/sort';
import { RulesPageRuleType } from '../../../../../../reducers/ipa/strategy/rulesPage/filters/type';
import { RulesPageFiltersValueState } from '../../../../../../reducers/ipa/strategy/rulesPage/filters/value';
import { RulesPageCustomRuleSortOptions } from '../../../../../../reducers/ipa/strategy/rulesPage/table/datakeys';
import { RulesPagePaginationState } from '../../../../../../reducers/ipa/strategy/rulesPage/table/pagination';
import { getSortModel } from '../../../../../../utils';
import { getValidData } from '../../../../RevisaoPrecos/utils';
import { RuleDataItem } from './service';

type GetRuleModelParams = {
  name: string;
  type: RulesPageRuleType;
  value: RulesPageFiltersValueState;
  sort: Sort;
  pagination: RulesPagePaginationState;
};

const DEFAULT_PAGE = 0;
const PAGE_COMPENSATION_VALUE = 1;

export const getRuleModel = (data: GetRuleModelParams) => {
  const { sensibilityType, ...value } = data.value;

  const getSensibility = (type: GerenciadorPrecos.Sensibilities) => {
    return sensibilityType?.filter(item => item?.type === type).map(item => item?.value) || null;
  };

  const params = {
    clientId: JSON.parse(localStorage.getItem('cliente') || '')?.codigo,
    type: data.type ?? 'AUTO_PRICE',
    name: data.name,
    page: data.pagination.page - PAGE_COMPENSATION_VALUE || DEFAULT_PAGE,
    size: data.pagination.size,
    sort: getSortModel(data.sort.type, data.sort.orderBy),
    sensibilities: getSensibility('infoPriceSensibility'),
    exclusive: getSensibility('sensibilityType'),
    curveAbcLocal: getSensibility('infoPriceAbcClass'),
    curveAbcGlobal: getSensibility('infoPriceGlobalAbcClass'),
    ...value,
  };

  return getValidData(params);
};

export type ListRulesParams = ReturnType<typeof getRuleModel>;

export const listFormater = new Intl.ListFormat('pt-BR', { style: 'long', type: 'conjunction' });

export const ruleCustomSortList: { label: string; value: RulesPageCustomRuleSortOptions }[] = [
  { label: 'Regra', value: 'name' },
  { label: 'Categoria ou Produto', value: 'productId' },
];

export const ruleCustomRortOptionsMap = new Map<RulesPageCustomRuleSortOptions, 'rule'>([
  ['name', 'rule'],
  ['productId', 'rule'],
]);

export const rulePaginationLengthMenu = [
  {
    value: 20,
    label: 20,
  },
  {
    value: 40,
    label: 40,
  },
];

type ParseSensibilityTypeParams = Pick<RuleDataItem, 'sensibilityType' | 'infoPriceSensibility' | 'infoPriceAbcClass' | 'infoPriceGlobalAbcClass' | 'abcClass'>;

const sensibilityTypeMap = new Map([
  ['SENSITIVE', 'Sensível'],
  ['NOT_SENSITIVE', 'Não sensível'],
  ['SUPER_SENSITIVE', 'Super sensível'],
]);

const parseSensibilityTypeValue = (sensibilityType: string[] | null = [], data?: Set<string>) => {
  sensibilityType?.forEach(item => {
    if (data) data.add(item);
  });
};

const parseInfoPriceSensibility = (infoPriceSensibility?: string[] | null, data?: Set<string>) => {
  infoPriceSensibility?.forEach(item => {
    const parsed = sensibilityTypeMap.get(item);
    if (parsed && data) data.add(parsed);
  });
};

const parseInfoPriceAbcClass = (infoPriceAbcClass?: string[] | null, data?: Set<string>) => {
  infoPriceAbcClass?.forEach(item => data && data.add(`Local ${item}`));
};

const parseInfoPriceGlobalAbcClass = (infoPriceGlobalAbcClass?: string[] | null, data?: Set<string>) => {
  infoPriceGlobalAbcClass?.forEach(item => data && data.add(`Global ${item}`));
};

const parseAbcClass = (abcClass?: string[] | null, data?: Set<string>) => {
  abcClass?.forEach(item => data && data.add(item));
};

const uppercase = (str: string | null): string => {
  return str ? str.toUpperCase() : '';
};

export const parseSensibilityType = ({
  sensibilityType,
  infoPriceSensibility,
  infoPriceAbcClass,
  infoPriceGlobalAbcClass,
  abcClass,
}: ParseSensibilityTypeParams): string => {
  const data = new Set<string>();

  parseSensibilityTypeValue(sensibilityType, data);
  parseInfoPriceSensibility(infoPriceSensibility, data);
  parseInfoPriceAbcClass(infoPriceAbcClass, data);
  parseInfoPriceGlobalAbcClass(infoPriceGlobalAbcClass, data);
  parseAbcClass(abcClass, data);

  return listFormater.format(Array.from(data).map(uppercase));
};
